import DreamsPage from './dreams-page';

export default DreamsPage;